
import { ITeamWebsite, ITournamentEditionMatch } from "../../../../../services";

export interface IMatchParticipant {
    name?: string;
    logo_url?: string;
    username?: string;
    external_id: string;
    profile_picture_url?: string;
}

export function matchParticipants(t: ITournamentEditionMatch): IMatchParticipant[] {
    return (t.tournament_edition_registered_participant_ids ?? []).map((external_id) => ({ ...t.extra_data?.participants_profiles?.[external_id], external_id }));
}

export function matchScores(t: ITournamentEditionMatch): number[] | undefined {
    const first = Object.values(t.scores ?? {})?.[0];
    if (!first) return undefined;
    return Object.values(first).map((s) => Object.values(s)?.[0]);
}

export function isHomeMatch(website: ITeamWebsite, t: ITournamentEditionMatch) {
    const [first] = matchParticipants(t);
    if (!first) return false;
    const flattened = JSON.stringify(t.extra_data?.participants_profiles?.[first.external_id + ""]);
    return (first.external_id === website.team.external_id || first.username === website.team.name)
        || (!!flattened && (flattened.includes(website.team.external_id) || flattened.includes(website.team.name)));
}

export function matchWon(t: ITournamentEditionMatch) {
    const scores = matchScores(t);
    return (scores?.[0] ?? 0) > (scores?.[1] ?? 0);
}

export function participantName(p: IMatchParticipant) {
    return p.name ?? p.username ?? "";
}

export function participantImage(p: IMatchParticipant) {
    return p.profile_picture_url ?? p.logo_url;
}
